import { memoize, minBy } from 'lodash';
import { createRefComponentsError, RefComponentsErrorCode, } from './RefComponentsError';
export function IsReferredComponent({ descriptor, key }, _propertyKey, _descriptor) {
    const originalMethod = descriptor.value;
    // ????
    descriptor.key = key;
    descriptor.kind = 'method';
    descriptor.placement = 'own';
    descriptor.value = function (ds, appDefinitionId, compRef) {
        if (!ds.components.refComponents.isReferredComponent(compRef)) {
            throw createRefComponentsError(RefComponentsErrorCode.CompIsNotAReferredCompError, 'Component is not a referred component').withComponentId(compRef.id);
        }
        // // TODO: try to understand whether or not we need to check the parent comp
        const hostRef = ds.components.refComponents.getRefHostCompPointer(compRef);
        if (!hostRef) {
            // should never happen in fact if component passes "isReferredComponent" check
            throw createRefComponentsError(RefComponentsErrorCode.UnableToFindAnOwnerError, 'Unable to find an owner of the component').withComponentId(compRef.id);
        }
        if (ds.components.data.get(hostRef)?.appDefinitionId !== appDefinitionId) {
            throw createRefComponentsError(RefComponentsErrorCode.NotAllowedToChangeRefComponent, "The component with doesn't belong to this app.").withComponentId(compRef.id);
        }
        // Call the original method
        return originalMethod.call(this, appDefinitionId, compRef);
    };
    return descriptor;
}
export function isRefComponent(ds, compRef) {
    return (ds.components.getType(compRef) === 'wysiwyg.viewer.components.RefComponent');
}
export function getFirstRefComponent(ds, compRef) {
    if (isRefComponent(ds, compRef)) {
        return compRef;
    }
    const refComponent = ds.components.refComponents.getRefHostCompPointer(compRef);
    if (!refComponent) {
        throw createRefComponentsError(RefComponentsErrorCode.UnableToFindRefComponent, 'Unable to find refComponent for the root component').withRootComponentId(compRef.id);
    }
    return refComponent;
}
const buildComponentTree = memoize((ds, componentRef) => {
    const connection = ds.platform.controllers.connections.getPrimaryConnection(componentRef);
    return {
        componentRef,
        role: connection?.role,
        children: ds.deprecatedOldBadPerformanceApis.components
            .getChildren(componentRef)
            .map((c) => buildComponentTree(ds, c)),
    };
}, (_ds, compRef) => compRef.id);
export const findComponentBySelectorInternal = (item, selectors, nestingLevel = 0) => {
    const topSelector = selectors[0];
    if (!topSelector) {
        return [];
    }
    if (topSelector === item.role) {
        selectors.shift();
    }
    if (selectors.length === 0) {
        return [{ item, nestingLevel }];
    }
    if (!item.children?.length) {
        return [];
    }
    const childResults = item.children?.map((child) => {
        return findComponentBySelectorInternal(child, selectors.slice(), nestingLevel++);
    });
    return childResults.flatMap((x) => x);
};
export const findComponentBySelector = (ds, rootCompRef, selector) => {
    const roles = selector
        .split(' ')
        .map((x) => x.trim())
        .map((x) => x.slice(1));
    const componentTree = buildComponentTree(ds, rootCompRef);
    const foundElements = findComponentBySelectorInternal(componentTree, roles);
    return minBy(foundElements, (x) => x.nestingLevel)?.item;
};
//# sourceMappingURL=helpers.js.map